import React, { useState } from "react";
import statWinner from "../../js/statWinner"

import Icon from "../Utilities/Icon"
import Modal from "../Utilities/Modal"
import ModalSeasonBreakdown from "../DetailedStats/ModalSeasonBreakdown"
import ButtonWithIcon from "../Utilities/ButtonWithIcon"
import * as styles from "./DetailedStatBars.module.css"


const DetailedStatBars = (props) => {

  const [modalActive, setModalActive] = useState(false);
  const toggleModal = () => setModalActive(prev => !prev);
  const hideModal = () => setModalActive(false);

  const competition =
  props.competition === "Other Club Cups" ? "All Time Cups"
  : props.competition === "League" ? "All Time League"
  : props.competition === "Champions League" ? "All Time Champions League"
  : props.competition === "International" ? "All Time Internationals"
  : props.competition === "League (Since 14/15)" ? "League Since 14"
  : props.competition === "League + Champs League" ? "League and Europe Since 09"
  : props.competition === "League/Champs League" ? "All Time League and Champions League"
  : props.competition

  const getData = (data) => {
    return data.filter(d => d.node.competition === competition).map(d => 
      ({
        'reboundGkAssist': Number(d.node.reboundGkAssist),
        'reboundPostAssist': Number(d.node.reboundPostAssist),
        'deflectedAssist': Number(d.node.deflectedAssist),
        'penWonAssist': Number(d.node.penWonAssist),
        'ownGoalAssist': Number(d.node.ownGoalAssist),
        'minsPlayed': d.node.minsPlayed,
        'subStat': parseFloat(d.node[Object.keys(d.node)[Object.keys(d.node).length - 2]]),
        'stat': parseFloat(d.node[Object.keys(d.node)[Object.keys(d.node).length - 1]])
      })
    )
  }

  const mdata = props.mdata ? props.mdata : getData(props.data.allSheetMessiAllTimeStats.edges)
  const rdata = props.rdata ? props.rdata : getData(props.data.allSheetRonaldoAllTimeStats.edges)

  const mstat =
    props.mstat ? props.mstat 
    : props.statType === "Goal Contributions" ? mdata.map(d => d.stat+d.subStat)
    : props.statType === "Goals Without Penalties" ? mdata.map(d => d.stat-d.subStat)
    : props.statType === "All Assist Types" && props.mainStatView === "Opta Assists" ? mdata.map(d => d.stat)
    : props.statType === "All Assist Types" && props.mainStatView === "Deflected Assists" ? mdata.map(d => d.deflectedAssist)
    : props.statType === "All Assist Types" && props.mainStatView === "GK Rebounds" ? mdata.map(d => d.reboundGkAssist)
    : props.statType === "All Assist Types" && props.mainStatView === "Post Rebounds" ? mdata.map(d => d.reboundPostAssist)
    : props.statType === "All Assist Types" && props.mainStatView === "Own Goal Assists" ? mdata.map(d => d.ownGoalAssist)
    : props.statType === "All Assist Types" && props.mainStatView === "Pens Won" ? mdata.map(d => d.penWonAssist)
    : props.statType === "All Assist Types" ? mdata.map(d => d.stat+d.reboundGkAssist+d.reboundPostAssist+d.deflectedAssist+d.penWonAssist+d.ownGoalAssist)
    : mdata.map(d => d.stat)

  const rstat =
    props.rstat ? props.rstat 
    : props.statType === "Goal Contributions" ? rdata.map(d => d.stat+d.subStat)
    : props.statType === "Goals Without Penalties" ? rdata.map(d => d.stat-d.subStat)
    : props.statType === "All Assist Types" && props.mainStatView === "Opta Assists" ? rdata.map(d => d.stat)
    : props.statType === "All Assist Types" && props.mainStatView === "Deflected Assists" ? rdata.map(d => d.deflectedAssist)
    : props.statType === "All Assist Types" && props.mainStatView === "GK Rebounds" ? rdata.map(d => d.reboundGkAssist)
    : props.statType === "All Assist Types" && props.mainStatView === "Post Rebounds" ? rdata.map(d => d.reboundPostAssist)
    : props.statType === "All Assist Types" && props.mainStatView === "Own Goal Assists" ? rdata.map(d => d.ownGoalAssist)
    : props.statType === "All Assist Types" && props.mainStatView === "Pens Won" ? rdata.map(d => d.penWonAssist)
    : props.statType === "All Assist Types" ? rdata.map(d => d.stat+d.reboundGkAssist+d.reboundPostAssist+d.deflectedAssist+d.penWonAssist+d.ownGoalAssist)
    : rdata.map(d => d.stat)
    
  const statW = props.statType === "xG (Expected Goals)" ? '' : statWinner(parseFloat(mstat), parseFloat(rstat))

  const msubStat = parseFloat(mdata.map(d => d.subStat))
  const rsubStat = parseFloat(rdata.map(d => d.subStat))

  const barCapacity = statW === "m" ? mstat : rstat

  const mBarHeight = mstat === 0 ? 0.2 : mstat/barCapacity
  const rBarHeight = rstat === 0 ? 0.2 : rstat/barCapacity

  return (

    <article className={`${styles.statBarBlock} text-center my-4 sm:my-6 lg:my-8 sm:w-1/2 lg:w-1/3 px-4 md:px-6 lg:px-8 ${props.topLevel === true && !props.showTopLevel ? 'hidden' : 'block'} ${!props.topLevel && props.showTopLevel === true ? 'hidden' : 'block'}`}>

    <h2 className={`mb-6 font-semibold uppercase tracking-wide xl:text-lg`}>{props.title || props.competition} <span className="block text-xs text-slate-500 font-light tracking-wider">{props.subtitle || props.statType} {props.since ? 'since '+props.since : ''}</span></h2>

      <div className={`${styles.barsWrap} flex w-full`}>

        <div className={`w-1/2 flex flex-col justify-end items-center mr-px`}>
          <h3 className="order-1 text-xs uppercase mt-1 tracking-wider text-slate-600">
            Messi <span className="sr-only">{props.playerTitleHidden}</span>
          </h3>
          <div className={`flex items-end flex-1 w-full`}>
            <div className={`rounded-t transition duration-300 flex items-center flex-col w-full relative font-semibold text-xl border-b border-messi ${mstat === 0 ? 'bg-transparent' : 'bg-messi'}`} style={{height:(mBarHeight*100)+'%'}}>
              <p className={`w-full p-3 pb-0 ${mBarHeight*100 < 25 ? 'absolute bottom-0 left-0' : ''}`}>
                {props.statType === "Average Match Ratings" ? parseFloat(mstat).toFixed(2) : mstat}
                {props.statType === "Penalties" ? <span className="text-xs opacity-50">/ {Math.round(msubStat)+Math.round(mstat)}</span> : ''}
                {props.statType === "xG (Expected Goals)" ? <span className="text-xs"> xG <span className="block">({msubStat} actual goals)</span></span> : ''}
                {props.statType === "xA (Expected Assists)" ? <span className="text-xs"> xA <span className="block">({msubStat} actual assists)</span></span> : ''}
                <span className="sr-only"> {props.statType}</span>
              </p>
              {statW === "m" ? <Icon iconName="icon-star" class="block text-highlight w-3 h-3 mt-1" /> : ''}
            </div>
          </div>
          {props.mSubStat ? (
            <div className={`${styles.subStat} w-full text-xs p-2 bg-noir-lighten10 rounded-b relative text-slate-400 flex-none`}>
              <span className="sr-only">Messi </span>
              {props.mSubStat} {props.subStatW === "m" ? <Icon iconName="icon-star" class="text-highlight" /> : ''}
            </div>
          ) : ''}
        </div>

        <div className={`w-1/2 flex flex-col justify-end items-center ml-px`}>
          <h3 className="order-1 text-xs uppercase mt-1 tracking-wider text-slate-600">
            Ronaldo <span className="sr-only">{props.playerTitleHidden}</span>
          </h3>
          <div className={`flex items-end flex-1 w-full`}>
            <div className={`rounded-t transition duration-300 flex items-center flex-col w-full relative font-semibold text-xl border-b border-ronaldo ${rstat === 0 ? 'bg-transparent' : 'bg-ronaldo'}`} style={{height:(rBarHeight*100)+'%'}}>
              <p className={`w-full p-3 pb-0 ${rBarHeight*100 < 25 ? 'absolute bottom-0 left-0' : ''}`}>
                {props.statType === "Average Match Ratings" ? parseFloat(rstat).toFixed(2) : rstat}
                {props.statType === "Penalties" ? <span className="text-xs opacity-50">/ {Math.round(rsubStat)+Math.round(rstat)}</span> : ''}
                {props.statType === "xG (Expected Goals)" ? <span className="text-xs"> xG <span className="block">({rsubStat} actual goals)</span></span> : ''}
                {props.statType === "xA (Expected Assists)" ? <span className="text-xs"> xA <span className="block">({rsubStat} actual assists)</span></span> : ''}
                <span className="sr-only"> {props.statType}</span>
              </p>
              {statW === "r" ? <Icon iconName="icon-star" class="block text-highlight w-3 h-3 mt-1" /> : ''}
            </div>
          </div>
          {props.rSubStat ? (
            <div className={`${styles.subStat} w-full text-xs p-2 bg-noir-lighten10 rounded-b relative text-slate-400 flex-none`}>
              <span className="sr-only">Ronaldo </span>
              {props.rSubStat} {props.subStatW === "r" ? <Icon iconName="icon-star" class="text-highlight" /> : ''}
            </div>
          ) : ''}
        </div>
        
      </div>

      {props.btnText !== "" ?
        <ButtonWithIcon
          id={`${props.competition.replace(/\s+/g, '')}${props.btnText.replace(/\s+/g, '')}`}
          ariaLabel={`${props.competition} ${props.btnText}`}
          handler={toggleModal}
          text={props.btnText}
          icon="icon-plus"
          margins="mt-4 xs:mt-4 md:mt-5"
          disabled={props.topLevel & props.topLevel !== "both" ? true : false}
        />
      : ''}

      {props.btnText !== "" ?
        <Modal
          handler={hideModal}
          state={modalActive}
          key={`sb${props.data}`}
          title={props.title ?? props.competition}
          subTitle={props.statType}
          subTitleTop="messivsronaldo.app"
        >
          <ModalSeasonBreakdown
            mdata={props.mdata || ''}
            rdata={props.rdata || ''}
            data={props.data || ''}
            competition={props.competition}
            statType={props.statType}
            statView={props.statView}
            since={props.since && props.since}
            showTopLevel={props.showTopLevel}
          />
        </Modal>
      : ''}

    </article>

  )
}

export default DetailedStatBars